import React, {useEffect, useReducer, useRef, useState} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {
  makeGetRequest,
  makePostRequest,
  GET_PROFILE_PAGE_DATA,
  getRowFieldsDataSelector,
  showCardsSelector,
  aisCardsSelector,
  addCardsData,
  userWalletInfoSelector,
  userSettingDataSelector,
} from '@ibibo/myaccount-reducer';
import * as S from './AisProfile.styles';
import {redirectToSameWindowWithoutRefresh, getCrid} from '../../../utils/redirectWithCrId';

import Modal from '../common/Modal/Modal';
import CTA from '../common/CTA/CTA';
import AisProfileLeftSection from './AisProfileLeftSection/AisProfileLeftSection';
import SuppliersProgressCard from './AisProfileRightSection/SupplierProgressCard/SupplierProgressCard';
import AisDetailsForm from './AisProfileRightSection/AisDetailsForm/AisDetailsForm';
import Agreement from '../common/Agreement/Agreement';
import OtpVerfied from '../../../../../onboarding/src/stories/components/OnboardingNew/CommonComponents/OtpVerified/OtpVerified';
import {useAnalyticService} from '@ibibo/analytics-provider';

const initialState = {
  profileData: {},
  openModal: false,
  modalData: {},
  agreementModal: false,
  verificationModal: false,
};

function stateReducer(state, action) {
  switch (action.type) {
    case 'UPDATE_PROFILE_DATA':
      return {...state, profileData: action.payload};
    case 'OPEN_MODAL':
      return {...state, openModal: true, modalData: action.payload};
    case 'SET_AGREEMENT_MODAL_FLAG':
      return {
        ...state,
        agreementModal: true,
        verificationModal: false,
      };
    case 'SET_VERIFICATION_MODAL':
      return {
        ...state,
        agreementModal: false,
        verificationModal: true,
        modalData: action?.payload,
      };
    case 'CLOSE_MODAL':
      return {...state, openModal: false};
    default:
      return state;
  }
}

const AisProfile = () => {
  const crId = getCrid();
  if (!crId) {
    redirectToSameWindowWithoutRefresh(`/mysuppliersettings`);
  }
  const dispatch = useDispatch();
  const rowFieldsData = useSelector(getRowFieldsDataSelector);
  const showCardsMemoData = useSelector(showCardsSelector);
  const aisCards = useSelector(aisCardsSelector);
  const refsArray = useRef([]);
  const userData = useSelector(userSettingDataSelector);
  const walletInfo = useSelector(userWalletInfoSelector);
  const {updateAnalyticDataStore, sendTrackingDataToSdk} = useAnalyticService();
  const [state, dispatchState] = useReducer(stateReducer, initialState);
  const [openModal, setOpenModal] = useState(false);

  const {
    profileData: {data = {}},
  } = state;

  const {rightSection, leftSection} = data || {};

  const {order = []} = rightSection || {};

  useEffect(() => {
    dispatch(
      makeGetRequest(
        GET_PROFILE_PAGE_DATA,
        fetchProfileDataSuccessCallback,
        fetchProfileDataErrorCallback,
      ),
    );
  }, []);

  useEffect(() => {
    dispatchState({type: 'UPDATE_PROFILE_DATA', payload: aisCards});
  }, [aisCards]);
  const loadPDTTrackingData = ({userData, walletInfo}) => {
    const {account_id, is_sub_user, uuid} = userData;

    const pdtTrackingData = {
      global: {
        payload: {
          campaign_details: {
            campaign_name: 'mypartner_direct',
            campaign_key: 'MYPARTNER',
          },
          event_tracking_context: {
            traffic_source: 'mypartner_direct',
            domain_country: 'india',
            domain_currency: 'INR',
            domain_language: 'eng',
            env: 'prod',
            bu: 'mypartner_core',
            organisation: 'MMT',
            funnel_source: 'mypartner_core',
            topic_name: 'mmt_core_mypartner_pdt_client_logging',
            producer: 'mypartner_core',
            template_id: 179775,
          },
          user_context: {
            user_type: is_sub_user ? 'Sub User' : 'Admin',
            agency_code: account_id?.value,
            profile_type: 'cta',
            uuid: uuid?.value || '',
            is_logged_in: true,
            logging_channel: null,
            wallet_bal: walletInfo?.tb,
          },
        },
      },
      pageLoad: {
        payload: {
          page_context: {
            lob: 'common',
            lob_category: 'common',
            page_title: null,
            page_name: 'supplier_settings',
            subpage_name: null,
            site_section: null,
            page_type: 'landing',
            percent_page_viewed: null,
            prev_page_name: null,
            travel_store: null,
            page_url: null,
            funnel_step: 'landing',
            page_state_journey: null,
            sub_lob: 'mypartner_core',
            pg_time_interval: null,
            platform: null,
          },
          coupon_details: null,
          cross_sell_details: null,
          addon_details: null,
          traveller_details_list: null,
          payment_details: null,
          campaign_details: null,
          event_detail: {
            event_name: 'page_entry',
            event_type: 'user_action',
            event_value: 'supplier_settings',
            components: null,
            client_travel_store_meta: null,
            interaction_type: null,
            booking_info: null,
          },
        },
      },
    };
    if (pdtTrackingData) {
      updateAnalyticDataStore?.(pdtTrackingData, 'SUPPLIER_SETTINGS');
      sendTrackingDataToSdk?.(pdtTrackingData, 'SUPPLIER_SETTINGS');
    }
  };
  const fetchProfileDataSuccessCallback = response => {
    dispatch(addCardsData(response?.data));
  };
  const fetchProfileDataErrorCallback = err => {};
  useEffect(() => {
    if (userData) {
      loadPDTTrackingData({userData, walletInfo});
    }
  }, [userData]);

  const onClickCB = data => {
    const {body, url} = data;
    for (const i in body) {
      body[i] = rowFieldsData[i];
    }

    dispatch(makePostRequest(url, body, successCallback, errorCallback));
  };

  const successCallback = resp => {
    //console.log(resp);
  };

  const errorCallback = err => {
    //console.log(err);
  };

  const openModalHandler = data => {
    dispatchState({type: 'OPEN_MODAL', payload: data});
    if (data?.modalKey === 'agreement') {
      dispatchState({type: 'SET_AGREEMENT_MODAL_FLAG'});
    }
  };

  const closeModalHandler = () => {
    dispatchState({type: 'CLOSE_MODAL'});
  };

  const changeModalType = (modalType, modalData) => {
    if (modalType === 'VERIFICATION_MODAL') {
      dispatchState({type: 'SET_VERIFICATION_MODAL', payload: modalData});
    }
  };

  const getDisableStatus = data => {
    const {requiredKeys} = data || {};
    for (let i = 0; i < requiredKeys?.length; i++) {
      if (
        (rowFieldsData[requiredKeys[i]] === undefined || rowFieldsData[requiredKeys[i]] === '') &&
        showCardsMemoData[requiredKeys[i]] === undefined
      ) {
        return false;
      }
    }
    return true;
  };

  const isLoadingApi = (flag = false) => {
    return !flag;
  };

  const getStyles = (flag, data) => {
    if (flag) {
      return data?.styles;
    } else {
      const customClassesArray: Array<string> = data?.styles?.customClasses || [];
      const arr2 = ['primaryBtn', 'NewSquare', 'regularActnBtn', 'pushRight'];
      customClassesArray.concat(arr2);
      return data?.styles;
    }
  };

  const renderCards = (element, index, item) => {
    switch (element?.component) {
      case 'PROFILE_CARD':
        return (
          <div id={item}>
            <AisDetailsForm
              customClass="appendBottom20"
              componentData={element}
              ref={refsArray[index]}
              componentName={item}
              sendTrackingDataToSdk={sendTrackingDataToSdk}
            />
          </div>
        );
      case 'PROFILE_COMPLETION_PENDING_SECTION':
        return <>{<SuppliersProgressCard {...element?.data} />}</>;
      default:
        return <></>;
    }
  };

  return (
    <S.ProfileMainWrap>
      <div className="aisWrap makeFlex dirColumn">
        {/* <AISHeader theme={theme} customClass={``} /> */}
        <div className="aisLandingWrpr">
          <div className="container">
            <div className="makeFlex">
              <div className="leftWrap">
                <AisProfileLeftSection {...leftSection} />
              </div>
              <div className="rightWrap">
                {rightSection?.order?.length &&
                  rightSection?.order.map((item, idx) => {
                    return (
                      <React.Fragment key={idx}>
                        {renderCards(rightSection[item], idx, item)}
                      </React.Fragment>
                    );
                  })}
                {rightSection?.ctas?.length &&
                  rightSection?.ctas.map(({component, data}, idx) => {
                    return (
                      <CTA
                        onClickCB={onClickCB}
                        component={component}
                        data={data}
                        style={
                          !getDisableStatus(data) ? getStyles(false, data) : getStyles(true, data)
                        }
                        openModal={openModalHandler}
                        isActive={getDisableStatus(data)}
                        //closeModal={handleCloseModalSubForm}
                      />
                    );
                  })}
              </div>
            </div>
          </div>
        </div>
      </div>
      {state?.openModal && (
        <Modal
          closeBtn={true}
          padding={'32px'}
          onClose={closeModalHandler}
          width={state?.verificationModal ? '400px' : '650px'}
          height={state?.verificationModal ? '400px' : '650px'}
        >
          {state?.agreementModal ? (
            <Agreement
              agreementData={rightSection[state?.modalData?.modalKey]}
              changeModalType={changeModalType}
            />
          ) : state?.verificationModal ? (
            <OtpVerfied
              heading={state?.modalData?.heading}
              headingIcon={true}
              message={state?.modalData?.data?.message}
              //inportantInfo={'communicationAddress?.sub_text'}
              isVerificationSuccessFull={true}
              height={'400px'}
              responseRedirectUrl={''}
              showLinkButton={true}
            />
          ) : (
            <></>
          )}
        </Modal>
      )}
    </S.ProfileMainWrap>
  );
};

export default AisProfile;
